import { MatxLoadable } from "matx";
import { authRoles } from "../../auth/authRoles";

const CreateStatusGroup = MatxLoadable({
    loader: () =>
        import ("./CreateStatusGroup")
})
const AllCreateStatusGroup = MatxLoadable({
    loader: () =>
        import ("./AllCreateStatusGroup")
})




// const settings = {
//     activeLayout: "layout1",
//     layout1Settings: {
//         topbar: {
//             show: false
//         },
//         leftSidebar: {
//             show: false,
//             mode: "close"
//         }
//     },
//     layout2Settings: {
//         mode: "full",
//         topbar: {
//             show: false
//         },
//         navbar: { show: false }
//     },
//     secondarySidebar: { show: false },
//     footer: { show: false }
// };

const CreateStatusGroupRoutes = [
    {
        path: "/create_status_group",
        component: AllCreateStatusGroup,
        // settings
    },

];

export default CreateStatusGroupRoutes;